import { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom'
import { CheckCircle, XCircle, Loader2 } from 'lucide-react'
import authService from '../../services/authService'

export default function EmailVerificationPage() {
  const { token } = useParams<{ token: string }>()
  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (token) {
      verifyEmail(token)
    }
  }, [token])

  const verifyEmail = async (verificationToken: string) => {
    try {
      const response = await authService.verifyEmail(verificationToken)
      setStatus('success')
      setMessage(response.message || 'Your email has been verified successfully!')
    } catch (error: unknown) {
      setStatus('error')
      const err = error as { response?: { data?: { message?: string } } }
      setMessage(err.response?.data?.message || 'Verification failed. The link may be expired.')
    }
  }

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center py-12 px-4">
      <div className="w-full max-w-md text-center">
        {status === 'loading' && (
          <div>
            <Loader2 className="h-16 w-16 text-primary-600 animate-spin mx-auto mb-4" />
            <h1 className="text-2xl font-bold mb-2">Verifying Email</h1>
            <p className="text-secondary-600">Please wait while we verify your email...</p>
          </div>
        )}

        {status === 'success' && (
          <div>
            <CheckCircle className="h-16 w-16 text-green-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold mb-2">Email Verified!</h1>
            <p className="text-secondary-600 mb-6">{message}</p>
            <Link to="/dashboard" className="btn btn-primary">
              Go to Dashboard
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div>
            <XCircle className="h-16 w-16 text-red-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold mb-2">Verification Failed</h1>
            <p className="text-secondary-600 mb-6">{message}</p>
            <div className="space-x-4">
              <Link to="/login" className="btn btn-primary">
                Go to Login
              </Link>
              <button className="btn btn-secondary">
                Resend Verification
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
